<template>
  <svg width="38" height="43" viewBox="0 0 38 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.8408 0.791321V42.8113" stroke="#F6C5C8" stroke-width="2" stroke-miterlimit="10" />
    <path d="M37.71 21.8156H0" stroke="#F6C5C8" stroke-width="2" stroke-miterlimit="10" />
    <path d="M9.3584 11.2463L28.3287 32.3849" stroke="#F6C5C8" stroke-width="2" stroke-miterlimit="10" />
    <path d="M28.3287 11.2463L9.3584 32.3849" stroke="#F6C5C8" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</template>

